const ADD_DELIVERY = 'addDelivery'

const obj = {
  ADD_DELIVERY,
}

export default obj
